<template>
  <a-modal
    :visible="visible"
    title="小票打印"
    :width="440"
    :footer="null"
    :maskClosable="true"
    :closable="true"
    getContainer="body"
    :wrapClassName="'receipt-modal-wrapper'"
    @cancel="handleClose"
  >
    <!-- 操作工具栏（打印时隐藏） -->
    <div class="receipt-toolbar no-print">
      <a-button type="primary" icon="printer" @click="handlePrint">打印</a-button>
      <a-button @click="handleClose">关闭</a-button>
    </div>

    <!-- 小票纸张区域 -->
    <div id="receipt-print-area" class="receipt-paper">
      <!-- 头部信息 -->
      <div class="r-header">
        <h2 class="r-store">{{ "营养坞" }}</h2>
        <div class="r-sub" v-if="header.branch_name || header.warehouse">
          分店：{{ header.branch_name }}<span v-if="header.branch_name && header.warehouse"> </span>
        </div>
        <div class="r-meta">
          <div>单号(NO.)：{{ header.receipt_no }}</div>
          <div v-if="header.order_status">订单状态：{{ header.order_status }}</div>
          <div>营业员：{{ header.salesperson }}</div>
          <div>交易时间：{{ header.transaction_time }}</div>

        </div>
      </div>

      <div class="r-divider"></div>

      <!-- 商品明细列表 -->
      <table class="r-items">
        <thead>
          <tr>
            <th class="col-name">品名</th>
            <th class="col-price">单价</th>
            <th class="col-qty">数量</th>
            <th class="col-sub">小计</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in items" :key="item.item_index">
            <td class="col-name">
              <div class="r-name">{{ item.name }}</div>
              <div v-if="item.barcode" class="r-extra">条码：{{ item.barcode }}</div>
              <div v-if="item.spec" class="r-extra">规格：{{ item.spec }}</div>
              <div v-if="item.is_gift" class="r-gift-tag">[赠品]</div>
              <div
                v-if="item.original_price_ref != null && Number(item.original_price_ref) !== Number(item.unit_price)"
                class="r-origin"
              >原价：{{ fmt(item.original_price_ref) }}</div>
            </td>
            <td class="col-price">{{ fmt(item.unit_price) }}</td>
            <td class="col-qty">{{ fmtQty(item.quantity) }}</td>
            <td class="col-sub">{{ fmt(item.subtotal) }}</td>
          </tr>
        </tbody>
      </table>

      <div class="r-divider"></div>

      <!-- 底部汇总与会员信息 -->
      <div class="r-summary">
        <div class="r-row"><span>总数量</span><span>{{ fmtQty(summary.total_quantity) }}</span></div>
        <div class="r-row"><span>商品金额</span><span>{{ fmt(summary.goods_amount) }}</span></div>
        <div class="r-row" v-if="Number(summary.plus_discount) > 0"><span>会员折扣</span><span>-{{ fmt(summary.plus_discount) }}</span></div>
        <div class="r-row" v-if="Number(summary.coupon_amount) > 0"><span>优惠券减免</span><span>-{{ fmt(summary.coupon_amount) }}</span></div>
        <div class="r-row" v-if="Number(summary.point_discount_amount) > 0"><span>积分抵扣</span><span>-{{ fmt(summary.point_discount_amount) }}</span></div>
<!--        <div class="r-row"><span>优惠金额</span><span>-{{ fmt(summary.discount_amount) }}</span></div>-->
        <div class="r-row r-total"><span>合计金额</span><span>{{ fmt(summary.total_amount_payable) }}</span></div>
        <div class="r-row"><span>实收金额</span><span>{{ fmt(summary.actual_received) }}</span></div>
        <div class="r-row"><span>付款方式</span><span>{{ summary.payment_method }}</span></div>
        <div class="r-row"><span>付款金额</span><span>{{ fmt(summary.paid_amount) }}</span></div>
      </div>

      <div v-if="hasMember" class="r-divider"></div>

      <div v-if="hasMember" class="r-member">
        <div class="r-row"><span>会员卡号</span><span>{{ summary.member_card_no }}</span></div>
        <div class="r-row"><span>会员姓名</span><span>{{ summary.member_name }}</span></div>
        <div class="r-row"><span>本次积分</span><span>{{ summary.points_earned }}</span></div>
        <div class="r-row"><span>剩余积分</span><span>{{ summary.points_remaining }}</span></div>
        <div v-if="header.remark">备注：{{ header.remark }}</div>
      </div>

      <div class="r-footer">谢谢惠顾，欢迎再次光临！</div>

      <!-- 尾部留白：便于打印机出纸后直接看到全部内容，无需往外拽 -->
      <div class="r-blank-line"></div>
      <div class="r-blank-line"></div>
      <div class="r-blank-line"></div>
      <div class="r-blank-line"></div>
      <div class="r-blank-line"></div>
    </div>
  </a-modal>
</template>

<script>
// 小票打印专用样式（用于隔离的 iframe，避免依赖主页面 scoped 样式）
const RECEIPT_PRINT_CSS = `
  html, body { margin: 0; padding: 0; background: #fff; }
  .receipt-paper {
    width: 80mm;
    background: #fff;
    color: #000;
    padding: 16px 12px;
    /* 等宽字体保证数字/金额列对齐；中文优先回落宋体(SimSun)，热敏机小字更锐利清晰 */
    font-family: 'Courier New', Courier, 'SimHei', 'Microsoft YaHei', 'SimSun', monospace;
    font-size: 18px;
    line-height: 1.5;
    font-weight: bold;
    box-sizing: border-box;
    /* 整张加粗 + 保纯黑，避免热敏头局部受热不足导致笔画断断续续 */
    text-rendering: optimizeLegibility;
    print-color-adjust: exact;
    -webkit-print-color-adjust: exact;
  }
  .r-header { text-align: center; }
  .r-header .r-store { font-size: 24px; font-weight: 700; margin: 0 0 4px; }
  .r-header .r-sub { font-size: 17px; margin-bottom: 8px; text-align: left; color: #000; font-weight: bold; }
  .r-header .r-meta { text-align: left; font-size: 17px; color: #000; font-weight: bold; }
  .r-header .r-meta div { margin-bottom: 2px; }
  .r-divider { border-top: 1px dashed #999; margin: 8px 0; }
  .r-items { width: 100%; border-collapse: collapse; }
  .r-items th, .r-items td { text-align: left; vertical-align: top; padding: 2px 0; }
  .r-items thead th { font-weight: 700; border-bottom: 1px solid #999; }
  .r-items .col-name { width: 46%; }
  .r-items .col-price { width: 18%; text-align: right; }
  .r-items .col-qty { width: 14%; text-align: right; }
  .r-items .col-sub { width: 22%; text-align: right; }
  .r-items .r-name { font-weight: 600; word-break: break-all; }
  .r-items .r-gift-tag { display: inline-block; color: #000; font-weight: bold; font-size: 15px; }
  .r-items .r-origin { font-size: 15px; color: #000; }
  .r-items .r-extra { font-size: 16px; color: #000; font-weight: bold; }
  .r-summary .r-row, .r-member .r-row { display: flex; justify-content: space-between; font-size: 17px; }
  .r-summary .r-row span:last-child, .r-member .r-row span:last-child { font-weight: 600; }
  .r-summary .r-row.r-total, .r-member .r-row.r-total {
    font-size: 20px; font-weight: 700; border-top: 1px solid #999; margin-top: 4px; padding-top: 4px;
  }
  .r-summary .r-row.r-total span:last-child, .r-member .r-row.r-total span:last-child { color: #000; }
  .r-footer { text-align: center; margin-top: 12px; font-size: 18px; color: #000; font-weight: bold; }
  .r-blank-line { height: 1.6em; }
`

export default {
  name: 'ReceiptPrintModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // 小票数据：{ header_info, items_list, summary_and_payment }
    receiptData: {
      type: Object,
      default: () => null
    }
  },
  computed: {
    header() {
      return (this.receiptData && this.receiptData.header_info) || {}
    },
    items() {
      return (this.receiptData && this.receiptData.items_list) || []
    },
    summary() {
      return (this.receiptData && this.receiptData.summary_and_payment) || {}
    },
    hasMember() {
      return !!(this.summary && this.summary.member_name)
    }
  },
  methods: {
    fmt(val) {
      const n = Number(val || 0)
      return n.toFixed(2)
    },
    fmtQty(val) {
      const n = Number(val || 0)
      return Number.isInteger(n) ? String(n) : n.toFixed(2)
    },
    handlePrint() {
      const el = document.getElementById('receipt-print-area')
      if (!el) {
        window.print()
        return
      }
      const PAPER_WIDTH_MM = 80
      const PX_TO_MM = 25.4 / 96 // 屏幕 96dpi：1px = 25.4/96 mm
      // 将小票内容写入独立的 iframe 打印，避免主页面大量隐藏 DOM 占位导致打印出多页空白
      // 注意：iframe 必须给真实尺寸（不能用 0 宽高），否则 Chrome 会把 0 高度的盒子当成
      // 一页空白纸，真实内容被挤到下一页，表现为“先出一页白纸再出内容”
      const iframe = document.createElement('iframe')
      iframe.setAttribute(
        'style',
        'position:fixed;left:-10000px;top:0;width:' + PAPER_WIDTH_MM + 'mm;height:10px;border:0;background:#fff;'
      )
      document.body.appendChild(iframe)
      const idoc = iframe.contentWindow.document
      idoc.open()
      idoc.write(
        '<!DOCTYPE html><html><head><meta charset="utf-8"><title>小票</title>' +
          '<style>' + RECEIPT_PRINT_CSS + '</style></head><body>' +
          '<div class="receipt-paper" id="receipt-paper-inner">' + el.innerHTML + '</div>' +
          '</body></html>'
      )
      idoc.close()
      // 动态测量小票真实高度，写入精确的纸张尺寸，避免内容不满时铺满整张纸
      const paper = idoc.getElementById('receipt-paper-inner')
      const contentPx = paper.getBoundingClientRect().height || paper.offsetHeight
      // 高度加 40mm 安全余量：吸收打印对话框“默认页边距”（常 5~20mm）
      // 以及热敏机撕纸间隙，确保无论弹窗边距怎么设，内容都会被整张送出来，无需往外拽
      const heightMm = Math.ceil(contentPx * PX_TO_MM) + 80
      // 让 iframe 自身高度等于内容高度，避免被当成 0 高度空白首页
      iframe.style.height = Math.ceil(contentPx + 4) + 'px'
      const pageStyle = idoc.createElement('style')
      pageStyle.textContent =
        '@page { size: ' + PAPER_WIDTH_MM + 'mm ' + heightMm + 'mm; margin: 0; }'
      idoc.head.appendChild(pageStyle)
      // 等一帧让 @page 样式生效、完成重排后再打印，避免首张分页错乱
      this.$nextTick(() => {
        iframe.contentWindow.focus()
        iframe.contentWindow.print()
        // 打印完成后移除 iframe
        setTimeout(() => {
          if (iframe.parentNode) {
            iframe.parentNode.removeChild(iframe)
          }
        }, 500)
      })
    },
    handleClose() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style scoped lang="less">
.receipt-toolbar {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-bottom: 16px;
}

.receipt-paper {
  width: 100%;
  background: #fff;
  color: #000;
  padding: 16px 12px;
  font-family: 'Courier New', 'Microsoft YaHei', monospace;
  font-size: 13px;
  line-height: 1.6;
  box-sizing: border-box;
}

.r-header {
  text-align: center;

  .r-store {
    font-size: 18px;
    font-weight: 700;
    margin: 0 0 4px;
  }

  .r-sub {
    font-size: 13px;
    margin-bottom: 8px;
    text-align: left;
    color: #000;
    font-weight: bold;
  }

  .r-meta {
    text-align: left;
    font-size: 13px;
    color: #000;
    font-weight: bold;

    div {
      margin-bottom: 2px;
    }
  }
}

.r-divider {
  border-top: 1px dashed #999;
  margin: 8px 0;
}

.r-items {
  width: 100%;
  border-collapse: collapse;

  th, td {
    text-align: left;
    vertical-align: top;
    padding: 2px 0;
  }

  thead th {
    font-weight: 700;
    border-bottom: 1px solid #999;
  }

  .col-name { width: 46%; }
  .col-price { width: 18%; text-align: right; }
  .col-qty { width: 14%; text-align: right; }
  .col-sub { width: 22%; text-align: right; }

  .r-name {
    font-weight: 600;
    word-break: break-all;
  }

  .r-gift-tag {
    display: inline-block;
    color: #000;
    font-weight: bold;
    font-size: 11px;
  }

  .r-origin {
    font-size: 11px;
    color: #000;
  }

  .r-extra {
    font-size: 12px;
    color: #000;
    font-weight: bold;
  }
}

.r-summary, .r-member {
  .r-row {
    display: flex;
    justify-content: space-between;
    font-size: 13px;

    span:last-child {
      font-weight: 600;
    }

    &.r-total {
      font-size: 15px;
      font-weight: 700;
      border-top: 1px solid #999;
      margin-top: 4px;
      padding-top: 4px;

      span:last-child {
        color: #000;
      }
    }
  }
}

.r-footer {
  text-align: center;
  margin-top: 12px;
  font-size: 13px;
  color: #000;
  font-weight: bold;
}
</style>
